var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 37.7142C11.1429 37.7142 3.9429 25.3714 3.60004 24.8571C3.25718 24.3428 3.25718 23.6571 3.60004 23.1428C3.9429 22.6285 11.1429 10.2856 24 10.2856C36.8572 10.2856 44.0572 22.6285 44.4 23.1428C44.7429 23.6571 44.7429 24.3428 44.4 24.8571C44.0572 25.3714 36.8572 37.7142 24 37.7142ZM7.20004 23.9999C8.91432 26.5714 14.9143 34.2856 24 34.2856C33.0858 34.2856 39.0857 26.5714 40.8 23.9999C39.0857 21.4285 33.0858 13.7142 24 13.7142C14.9143 13.7142 8.91432 21.4285 7.20004 23.9999Z",
    fill: "#04BA96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.0001 30.8571C20.2287 30.8571 17.1429 27.7714 17.1429 24C17.1429 20.2285 20.2287 17.1428 24.0001 17.1428C27.7715 17.1428 30.8572 20.2285 30.8572 24C30.8572 27.7714 27.7715 30.8571 24.0001 30.8571ZM24.0001 20.5714C22.1144 20.5714 20.5715 22.1143 20.5715 24C20.5715 25.8857 22.1144 27.4285 24.0001 27.4285C25.8858 27.4285 27.4287 25.8857 27.4287 24C27.4287 22.1143 25.8858 20.5714 24.0001 20.5714Z",
    fill: "#7A7B93"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/EyeIcon.2dfd30d4ca67e79665a7b2d409c8af92.svg";
export { ForwardRef as ReactComponent };